import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { Card, CardContent } from './ui/card';
import { Loader2, Wallet, Receipt } from 'lucide-react';

const gbp = (v) =>
  `£${(parseFloat(v) || 0).toLocaleString('en-GB', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

/**
 * Running totals (not affected by the dashboard period filter) of unpaid
 * deposit invoices and unpaid final-payment invoices.
 */
export const OutstandingInvoicesBar = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/dashboard/outstanding-invoices')
      .then((r) => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Card className="border-slate-200" data-testid="outstanding-invoices-bar">
      <CardContent className="p-0">
        {loading ? (
          <div className="flex items-center justify-center h-24">
            <Loader2 className="w-5 h-5 animate-spin text-slate-400" />
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-slate-100">
            <div className="bg-white p-5 flex items-center gap-4" data-testid="outstanding-deposits">
              <div className="w-11 h-11 rounded-xl bg-amber-100 flex items-center justify-center flex-shrink-0">
                <Wallet className="w-5 h-5 text-amber-600" />
              </div>
              <div>
                <p className="text-sm text-slate-500 font-medium">Outstanding deposit invoices</p>
                <p className="text-2xl font-bold text-slate-900 mt-0.5">{gbp(data?.deposit_total)}</p>
                <p className="text-xs text-slate-400">{data?.deposit_count || 0} invoice(s)</p>
              </div>
            </div>
            <div className="bg-white p-5 flex items-center gap-4" data-testid="outstanding-finals">
              <div className="w-11 h-11 rounded-xl bg-rose-100 flex items-center justify-center flex-shrink-0">
                <Receipt className="w-5 h-5 text-rose-600" />
              </div>
              <div>
                <p className="text-sm text-slate-500 font-medium">Outstanding final payments</p>
                <p className="text-2xl font-bold text-slate-900 mt-0.5">{gbp(data?.final_total)}</p>
                <p className="text-xs text-slate-400">{data?.final_count || 0} invoice(s)</p>
              </div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default OutstandingInvoicesBar;
